import { Document, Page } from "react-pdf";
import PagingControl from "../esign/PagingControl";
import { useEffect, useState } from "react";

const ViewPdf = ({ width, height, pdf, setPageD, sePageN, setups = true, resetPage = null, onLoadError = null }) => {

    const [pageNum, setPageNum] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [pageDetails, setPageDetails] = useState(null);

    useEffect(() => {
        if (setups) {
            sePageN(pageNum)
        }
    }, [pageNum])

    useEffect(() => {
        if (setups) {
            setPageD(pageDetails)
        }
    }, [pageDetails])

    useEffect(() => {
        if (resetPage !== null) {
            setPageNum(resetPage)
        }
    }, [resetPage])
    return (
        <div>
            <Document
                file={pdf}
                onLoadSuccess={(data) => {
                    setTotalPages(data.numPages);
                }}
                onLoadError={(error) => {
                    if (onLoadError) onLoadError(error);
                }}
            >
                <Page
                    className='flex'
                    pageNumber={pageNum + 1}
                    width={width ?? ''}
                    height={height ?? ''}
                    onLoadSuccess={(data) => {
                        setPageDetails(data);
                    }}
                    onLoadError={(error) => {
                        if (onLoadError) onLoadError(error);
                    }}
                />
            </Document>

            <PagingControl
                pageNum={pageNum}
                setPageNum={setPageNum}
                totalPages={totalPages}
            />
        </div>

    )
}
export default ViewPdf;
